import { Box, styled, TextField, Typography } from '@mui/material'
import { FC, useState } from 'react'
import { ChangeEmailDialog } from '../../../../dialogs/ChangeEmailDialog'
import { useUserStore } from '../../../../store/storeUser'
import { ActionButton } from './ActionButton'
import { Block } from './Block'

const StyledTextField = styled(TextField)(() => ({
    '& .MuiOutlinedInput-root': {
        border: 'none',
        '& .MuiOutlinedInput-input.Mui-disabled': {
            padding: '0',
            color: '#121317',
        },
    },
}))

const BlockInnerWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    paddingBottom: '16px',
    borderBottom: '1px solid #E9EAED',
    [theme.breakpoints.down('sm')]: {
        paddingBottom: 0,
        borderBottom: 0,
        flexDirection: 'column',
        gap: '16px',
    },
}))

const EmailWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: '35%',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
        paddingBottom: '16px',
        width: '100%',
        borderBottom: '1px solid #E9EAED',
    },
}))

export const UserData: FC = () => {
    const [open, setOpen] = useState(false)
    const { userPersonalData } = useUserStore()
    const { email } = userPersonalData || {}

    return (
        <>
            <Block>
                <Typography
                    variant="h4"
                    sx={{
                        mb: '24px',
                    }}>
                    Данные аккаунта
                </Typography>
                <BlockInnerWrapper>
                    <EmailWrapper>
                        <StyledTextField
                            fullWidth
                            disabled
                            id="user_email"
                            name="email"
                            value={email}
                            variant="outlined"
                            label="Email"
                            margin="normal"
                        />
                    </EmailWrapper>

                    <ActionButton
                        disabled={!email}
                        sx={{
                            marginLeft: 'auto',
                        }}
                        onClick={() => setOpen(true)}
                        variant="outlined">
                        Изменить
                    </ActionButton>
                </BlockInnerWrapper>
            </Block>
            <ChangeEmailDialog open={open} onClose={() => setOpen(false)} />
        </>
    )
}
